// Validation utility functions
export const validateEmail = (email) => {
  // Basic email validation with TLD check
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return email ? emailRegex.test(email) : true; // Return true if email is empty (optional field)
};

// Add more validation functions here as needed
export const validatePhoneNumber = (phone) => {
  // Validate 10-digit phone number
  const phoneRegex = /^\d{10}$/;
  return phoneRegex.test(phone);
};

// Export all validations as a single object for convenience
export const validations = {
  email: validateEmail,
  phone: validatePhoneNumber,
  // Add more validations here
};

export default validations;
